import { isDev } from '@shared/utils/environment';
import { isMobileBrowser } from '@shared/utils/layout/isMobileBrowser';

import { getBlueGreenValue } from './utils';
import { getEnvValue, isTrue } from '../helpers/configHelper';

export const REACT_BLUE_APP_API_BASE_URL = 'VITE_REACT_BLUE_APP_API_BASE_URL';
export const REACT_GREEN_APP_API_BASE_URL = 'VITE_REACT_GREEN_APP_API_BASE_URL';

export const REACT_BLUE_APP_ENV_BASE_URL = 'VITE_REACT_BLUE_APP_ENV_BASE_URL';
export const REACT_GREEN_APP_ENV_BASE_URL = 'VITE_REACT_GREEN_APP_ENV_BASE_URL';

export const REACT_BLUE_APP_REF = 'VITE_REACT_BLUE_APP_REF';
export const REACT_GREEN_APP_REF = 'VITE_REACT_GREEN_APP_REF';

export const REACT_APP_NAME = 'VITE_REACT_APP_NAME';
export const REACT_APP_ENABLE_LOG = 'VITE_REACT_APP_ENABLE_LOG';
export const REACT_APP_ENV_KEY = 'VITE_REACT_APP_ENV_KEY';
export const REACT_APP_CMS_HOMEBASE_URL = 'VITE_REACT_APP_CMS_HOMEBASE_URL';
export const REACT_APP_CMS_REF = 'VITE_REACT_APP_CMS_REF';
export const REACT_APP_MAPS_REF = 'VITE_REACT_APP_MAPS_REF';
export const REACT_APP_CAPTCHA_WIDGET = 'VITE_REACT_APP_CAPTCHA_WIDGET';
export const REACT_APP_CAPTCHA_WIDGET_V3 = 'VITE_REACT_APP_CAPTCHA_WIDGET_V3';
export const REACT_APP_PUBLIC_FAQ_LINK = 'VITE_REACT_APP_PUBLIC_FAQ_LINK';
export const REACT_APP_HAS_NUP_MAMMOGRAM_LINK = 'VITE_REACT_APP_HAS_NUP_MAMMOGRAM_LINK';
export const REACT_APP_GOOGLE_ANALYTICS_ID = 'VITE_REACT_APP_GOOGLE_ANALYTICS_ID';
export const REACT_APP_GTM_CONTAINER_ID = 'VITE_REACT_APP_GTM_CONTAINER_ID';
export const REACT_APP_WOGAA_ENABLED = 'VITE_REACT_APP_WOGAA_ENABLED';
export const REACT_APP_VALIDATE_DAYS_LIMIT = 'VITE_REACT_APP_VALIDATE_DAYS_LIMIT';
export const REACT_APP_LAB_RESULTS_DAYS_LIMIT = 'VITE_REACT_APP_LAB_RESULTS_VALIDATE_DAYS_LIMIT';
export const REACT_APP_HISTO_CYTO_DAYS_LIMIT = 'VITE_REACT_APP_HISTO_CYTO_VALIDATE_DAYS_LIMIT';
export const REACT_APP_HISTO_CYTO_DELAY_DAYS = 'VITE_REACT_APP_HISTO_CYTO_DELAY_DAYS';
export const REACT_APP_HISTO_CYTO_EFFECT_DATE = 'VITE_REACT_APP_HISTO_CYTO_EFFECT_DATE';
export const REACT_APP_HISTO_CYTO_START_DATE = 'VITE_REACT_APP_HISTO_CYTO_START_DATE';
export const REACT_APP_HISTO_CYTO_END_DATE = 'VITE_REACT_APP_HISTO_CYTO_END_DATE';
export const REACT_APP_HISTO_CYTO_PAGINATION_OFFSET = 'VITE_REACT_APP_HISTO_CYTO_PAGINATION_OFFSET';
export const REACT_APP_PRESCRIPTION_VALIDATE_DAYS_LIMIT = 'VITE_REACT_APP_PRESCRIPTION_VALIDATE_DAYS_LIMIT';
export const REACT_APP_DISCHARGE_VALIDATE_DAYS_LIMIT = 'VITE_REACT_APP_DISCHARGE_VALIDATE_DAYS_LIMIT';
export const REACT_APP_MRRP_VALIDATE_DAYS_LIMIT = 'VITE_REACT_APP_MRRP_VALIDATE_DAYS_LIMIT';
export const REACT_APP_NEHR_ACCESS_HISTORY_VALIDATE_DAYS_LIMIT =
  'VITE_REACT_APP_NEHR_ACCESS_HISTORY_VALIDATE_DAYS_LIMIT';
export const REACT_APP_RADIOLOGY_VALIDATE_DAYS_LIMIT = 'VITE_REACT_APP_RADIOLOGY_VALIDATE_DAYS_LIMIT';
export const REACT_APP_HEALTH_SCREENING_VALIDATE_DAYS_LIMIT = 'VITE_REACT_APP_HEALTH_SCREENING_VALIDATE_DAYS_LIMIT';
export const REACT_APP_HEALTHRECORDS_SCREENING_VALIDATE_DAYS_LIMIT =
  'VITE_REACT_APP_HEALTHRECORDS_SCREENING_VALIDATE_DAYS_LIMIT';
export const REACT_APP_DEFAULT_PAGINATION_OFFSET = 'VITE_REACT_APP_DEFAULT_PAGINATION_OFFSET';
export const REACT_APP_NEHR_ACCESS_HISTORY_PAGINATION_OFFSET = 'VITE_REACT_APP_NEHR_ACCESS_HISTORY_PAGINATION_OFFSET';
export const REACT_APP_RADIOLOGY_PAGINATION_OFFSET = 'VITE_REACT_APP_RADIOLOGY_PAGINATION_OFFSET';
export const REACT_APP_RADIOLOGY_START_DATE = 'VITE_REACT_APP_RADIOLOGY_START_DATE';
export const REACT_APP_RADIOLOGY_END_DATE = 'VITE_REACT_APP_RADIOLOGY_END_DATE';
export const REACT_APP_RADIOLOGY_DELAY_DAYS = 'VITE_REACT_APP_RADIOLOGY_DELAY_DAYS';
export const REACT_APP_RADIOLOGY_EFFECT_DATE = 'VITE_REACT_APP_RADIOLOGY_EFFECT_DATE';
export const REACT_APP_REACT_PUBLIC_URL = 'VITE_REACT_PUBLIC_URL';
// Adding GENETIC_REPORTS constants
export const REACT_APP_GENETIC_REPORTS_VALIDATE_DAYS_LIMIT = 'VITE_REACT_APP_GENETIC_REPORTS_VALIDATE_DAYS_LIMIT';
export const REACT_APP_GENETIC_REPORTS_PAGINATION_OFFSET = 'VITE_REACT_APP_GENETIC_REPORTS_PAGINATION_OFFSET';
export const REACT_APP_GENETIC_REPORTS_START_DATE = 'VITE_REACT_APP_GENETIC_REPORTS_START_DATE';
export const REACT_APP_GENETIC_REPORTS_EFFECT_DATE = 'VITE_REACT_APP_GENETIC_REPORTS_EFFECT_DATE';
export const REACT_APP_GENETIC_REPORTS_END_DATE = 'VITE_REACT_APP_GENETIC_REPORTS_END_DATE';
export const REACT_APP_GENETIC_REPORTS_DELAY_DAYS = 'VITE_REACT_APP_GENETIC_REPORTS_DELAY_DAYS';
export const REACT_APP_SDC_APPOINTMENT = 'VITE_REACT_SDC_APPOINTMENT';
export const REACT_APP_SHC_APPOINTMENT = 'VITE_REACT_SHC_APPOINTMENT';
export const REACT_MOBILE_AUTH_APP_C_REF = 'VITE_REACT_MOBILE_AUTH_APP_C_REF';
export const REACT_DESKTOP_AUTH_APP_C_REF = 'VITE_REACT_DESKTOP_AUTH_APP_C_REF';
export const REACT_AUTH_SCOPE = 'VITE_REACT_AUTH_SCOPE';
export const REACT_AUTH_AUTHORITY = 'VITE_REACT_AUTH_AUTHORITY';
export const REACT_AUTH_C_SC = 'VITE_REACT_AUTH_C_SC';
export const REACT_PSS_QUESTION_URL = 'VITE_REACT_PSS_QUESTION_URL';
export const REACT_DEV = 'DEV';
export const REACT_APP_IQUIT_SMOKING_LINK = 'VITE_REACT_APP_IQUIT_SMOKING_LINK';
export const REACT_APP_CMS_COOKIE = 'VITE_REACT_APP_CMS_COOKIE';
export const REACT_APP_SESSION_COOKIE = 'VITE_REACT_APP_SESSION_COOKIE';
export const REACT_APP_CMS_COOKIE_DOMAIN = 'VITE_REACT_APP_CMS_COOKIE_DOMAIN';
export const REACT_CA_CHATBOT_URL = 'VITE_REACT_CA_CHATBOT_URL';
export const REACT_PUBLIC_CA_CHATBOT_URL = 'VITE_REACT_PUBLIC_CA_CHATBOT_URL';
export const REACT_KAKI_CHATBOT_URL = 'VITE_REACT_KAKI_CHATBOT_URL';
/**
 * Obtains the API's base URL from environment variables
 *
 * @throws  Throws an error if this variable could not be found
 */

const appName = (): string => getEnvValue(REACT_APP_NAME);

const apiBaseUrl = (): string =>
  getBlueGreenValue(getEnvValue(REACT_BLUE_APP_API_BASE_URL), getEnvValue(REACT_GREEN_APP_API_BASE_URL));

const envBaseUrl = (): string =>
  getBlueGreenValue(getEnvValue(REACT_BLUE_APP_ENV_BASE_URL), getEnvValue(REACT_GREEN_APP_ENV_BASE_URL));

/**
 * Obtains the log configuration from environment variables
 *
 * @throws  Throws an error if this variable could not be found
 */
const enableLogs = (): boolean => isTrue(REACT_APP_ENABLE_LOG);

/**
 * Current API Key.
 *
 * @throws  Throws an error if this variable could not be found
 */
const appApiKey = (): string => getBlueGreenValue(getEnvValue(REACT_BLUE_APP_REF), getEnvValue(REACT_GREEN_APP_REF));

/**
 * Current API ENV Key.
 *
 * @throws  Throws an error if this variable could not be found
 */
const appEnvKey = (): string => getEnvValue(REACT_APP_ENV_KEY);

/**
 * SITECORE Home Page
 *
 * @throws  Throws an error if this variable could not be found
 */
const sitecoreHomeBaseUrl = (): string => getEnvValue(REACT_APP_CMS_HOMEBASE_URL);

const sitecoreApiKey = (): string => getEnvValue(REACT_APP_CMS_REF);

const getPublicFAQUrl = (): string => getEnvValue(REACT_APP_PUBLIC_FAQ_LINK);

const getHasNupMammogramUrl = (): string => getEnvValue(REACT_APP_HAS_NUP_MAMMOGRAM_LINK);

const getValidateDaysLimit = (): number => Number(getEnvValue(REACT_APP_VALIDATE_DAYS_LIMIT));

const getLabResultsDaysLimit = (): number => Number(getEnvValue(REACT_APP_LAB_RESULTS_DAYS_LIMIT));

const getHistoCytoDaysLimit = (): number => Number(getEnvValue(REACT_APP_HISTO_CYTO_DAYS_LIMIT));

const getHistoCytoDelayDays = (): number => Number(getEnvValue(REACT_APP_HISTO_CYTO_DELAY_DAYS));

const getHistoCytoStartDate = (): string => getEnvValue(REACT_APP_HISTO_CYTO_START_DATE);

const getHistoCytoEndDate = (): number => Number(getEnvValue(REACT_APP_HISTO_CYTO_END_DATE));

const getHistoCytoEffectDate = (): number => Number(getEnvValue(REACT_APP_HISTO_CYTO_EFFECT_DATE));

const getHistoCytoPaginationOffset = (): number => Number(getEnvValue(REACT_APP_HISTO_CYTO_PAGINATION_OFFSET));

const getRadioLogyDaysLimit = (): number => Number(getEnvValue(REACT_APP_RADIOLOGY_VALIDATE_DAYS_LIMIT));

const getHealthScreeningDaysLimit = (): number => Number(getEnvValue(REACT_APP_HEALTH_SCREENING_VALIDATE_DAYS_LIMIT));

const getHealthRecordsScreeningDaysLimit = (): number =>
  Number(getEnvValue(REACT_APP_HEALTHRECORDS_SCREENING_VALIDATE_DAYS_LIMIT));

const getNehrAccessHistoryPaginationOffset = (): number =>
  Number(getEnvValue(REACT_APP_NEHR_ACCESS_HISTORY_PAGINATION_OFFSET));

const getRadiologyPaginationOffset = (): number => Number(getEnvValue(REACT_APP_RADIOLOGY_PAGINATION_OFFSET));

const getRadiologyStartDate = (): string => getEnvValue(REACT_APP_RADIOLOGY_START_DATE);

const getRadiologyEndDate = (): string => getEnvValue(REACT_APP_RADIOLOGY_END_DATE);

const getRadiologyDelayDays = (): number => Number(getEnvValue(REACT_APP_RADIOLOGY_DELAY_DAYS));

const getRadiologyEffectDate = (): string => getEnvValue(REACT_APP_RADIOLOGY_EFFECT_DATE);

// Adding GENETIC_REPORTS getter functions
const getGeneticReportsDaysLimit = (): number => Number(getEnvValue(REACT_APP_GENETIC_REPORTS_VALIDATE_DAYS_LIMIT));

const getGeneticReportsPaginationOffset = (): number =>
  Number(getEnvValue(REACT_APP_GENETIC_REPORTS_PAGINATION_OFFSET));

const getGeneticReportsStartDate = (): string => getEnvValue(REACT_APP_GENETIC_REPORTS_START_DATE);

const getGeneticReportsEffectDate = (): string => getEnvValue(REACT_APP_GENETIC_REPORTS_EFFECT_DATE);

const getGeneticReportsEndDate = (): string => getEnvValue(REACT_APP_GENETIC_REPORTS_END_DATE);

const getGeneticReportsDelayDays = (): number => Number(getEnvValue(REACT_APP_GENETIC_REPORTS_DELAY_DAYS));

const getPrescriptionValidateDaysLimit = (): number => Number(getEnvValue(REACT_APP_PRESCRIPTION_VALIDATE_DAYS_LIMIT));

const getDischargeValidateDaysLimit = (): number => Number(getEnvValue(REACT_APP_DISCHARGE_VALIDATE_DAYS_LIMIT));

const getMRPPValidateDaysLimit = (): number => Number(getEnvValue(REACT_APP_MRRP_VALIDATE_DAYS_LIMIT));

const getValidateNehrAccessHistoryDaysLimit = (): number =>
  Number(getEnvValue(REACT_APP_NEHR_ACCESS_HISTORY_VALIDATE_DAYS_LIMIT));

const getDefaultPaginationOffset = (): number => Number(getEnvValue(REACT_APP_DEFAULT_PAGINATION_OFFSET));

/**
 * Google api key
 *
 * @throws  Throws an error if this variable could not be found
 */
const googleApiKey = (): string => getEnvValue(REACT_APP_MAPS_REF);

/**
 * Google reCaptcha
 *
 * @throws  Throws an error if this variable could not be found
 */
const googleCaptchaSitekey = (): string => getEnvValue(REACT_APP_CAPTCHA_WIDGET);

/**
 * Google reCaptcha v3
 *
 * @throws  Throws an error if this variable could not be found
 */
const googleCaptchaSitekeyV3 = (): string => getEnvValue(REACT_APP_CAPTCHA_WIDGET_V3);

/**
 * Google Analytics
 *
 * @throws  Throws an error if this variable could not be found
 */
const googleAnalyticsId = () => getEnvValue(REACT_APP_GOOGLE_ANALYTICS_ID);

const googleTagManagerContainerId = () => getEnvValue(REACT_APP_GTM_CONTAINER_ID);

/**
 * WOGAA (Whole-of-Government Application Analytics) transactional tracking
 *
 * Gates whether `useWOGAA` actually calls into `window.wogaaCustom`. Per-flow tracking IDs are
 * resolved at runtime from System Settings (see `WogaaTrackingSettings` + `useGetSystemSettingsQuery`
 * in `RouteWrapper`), not from env vars, since they can change without a rebuild/redeploy.
 */
const wogaaEnabled = (): boolean => isTrue(REACT_APP_WOGAA_ENABLED);

const getPublicUrl = () => getEnvValue(REACT_APP_REACT_PUBLIC_URL);

const getSDCFormAppointment = () => getEnvValue(REACT_APP_SDC_APPOINTMENT);

const getSHCFormAppointment = () => getEnvValue(REACT_APP_SHC_APPOINTMENT);

const authClientId = () =>
  isMobileBrowser() ? getEnvValue(REACT_MOBILE_AUTH_APP_C_REF) : getEnvValue(REACT_DESKTOP_AUTH_APP_C_REF);

const authScope = () => getEnvValue(REACT_AUTH_SCOPE);

const authAuthority = () => getEnvValue(REACT_AUTH_AUTHORITY);

const authClientSecret = () => getEnvValue(REACT_AUTH_C_SC);

const getPSSQuestionUrl = () => getEnvValue(REACT_PSS_QUESTION_URL);

const getIQuitSmokingUrl = (): string => getEnvValue(REACT_APP_IQUIT_SMOKING_LINK);

const getSitecoreCookie = (): string => getEnvValue(REACT_APP_CMS_COOKIE);

const getSessionCookie = (): string => getEnvValue(REACT_APP_SESSION_COOKIE);

const getSitecoreCookieDomain = (): string => getEnvValue(REACT_APP_CMS_COOKIE_DOMAIN);
const getCAChatbotUrl = (): string =>
  isDev() ? getEnvValue(REACT_CA_CHATBOT_URL) : envBaseUrl() + getEnvValue(REACT_CA_CHATBOT_URL);

const getPublicCAChatbotUrl = (): string =>
  isDev() ? getEnvValue(REACT_PUBLIC_CA_CHATBOT_URL) : envBaseUrl() + getEnvValue(REACT_PUBLIC_CA_CHATBOT_URL);

const getKakiChatbotUrl = (): string =>
  isDev() ? getEnvValue(REACT_KAKI_CHATBOT_URL) : envBaseUrl() + getEnvValue(REACT_KAKI_CHATBOT_URL);

const getOptionalEnvVarKeys = (): string[] => [
  REACT_APP_HISTO_CYTO_START_DATE,
  REACT_APP_HISTO_CYTO_END_DATE,
  REACT_APP_HISTO_CYTO_DELAY_DAYS,
  REACT_APP_RADIOLOGY_START_DATE,
  REACT_APP_RADIOLOGY_END_DATE,
  REACT_APP_RADIOLOGY_DELAY_DAYS,
  REACT_APP_GENETIC_REPORTS_START_DATE,
  REACT_APP_GENETIC_REPORTS_END_DATE,
  REACT_APP_GENETIC_REPORTS_DELAY_DAYS,
];

export {
  apiBaseUrl,
  appApiKey,
  appEnvKey,
  appName,
  authAuthority,
  authClientId,
  authClientSecret,
  authScope,
  enableLogs,
  envBaseUrl,
  getCAChatbotUrl,
  getDefaultPaginationOffset,
  getDischargeValidateDaysLimit,
  getGeneticReportsDaysLimit,
  getGeneticReportsDelayDays,
  getGeneticReportsEffectDate,
  getGeneticReportsEndDate,
  getGeneticReportsPaginationOffset,
  getGeneticReportsStartDate,
  getHasNupMammogramUrl,
  getHealthRecordsScreeningDaysLimit,
  getHealthScreeningDaysLimit,
  getHistoCytoDaysLimit,
  getHistoCytoDelayDays,
  getHistoCytoEffectDate,
  getHistoCytoEndDate,
  getHistoCytoPaginationOffset,
  getHistoCytoStartDate,
  getIQuitSmokingUrl,
  getKakiChatbotUrl,
  getLabResultsDaysLimit,
  getMRPPValidateDaysLimit,
  getNehrAccessHistoryPaginationOffset,
  getOptionalEnvVarKeys,
  getPrescriptionValidateDaysLimit,
  getPSSQuestionUrl,
  getPublicCAChatbotUrl,
  getPublicFAQUrl,
  getPublicUrl,
  getRadioLogyDaysLimit,
  getRadiologyDelayDays,
  getRadiologyEffectDate,
  getRadiologyEndDate,
  getRadiologyPaginationOffset,
  getRadiologyStartDate,
  getSDCFormAppointment,
  getSessionCookie,
  getSHCFormAppointment,
  getSitecoreCookie,
  getSitecoreCookieDomain,
  getValidateDaysLimit,
  getValidateNehrAccessHistoryDaysLimit,
  googleAnalyticsId,
  googleApiKey,
  googleCaptchaSitekey,
  googleCaptchaSitekeyV3,
  googleTagManagerContainerId,
  sitecoreApiKey,
  sitecoreHomeBaseUrl,
  wogaaEnabled,
};
